<button (click)="changeTheme()"  mat-icon-button class="m-r-5">
    <i-tabler [name]="selectedTheme"></i-tabler>
</button>
